<template>
  <Teleport to="body">
    <div class="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 flex flex-col gap-3">

      <div v-for="item in toastList" :key="item.id"
        class="flex items-center gap-2.5 rounded-[var(--radius-full)] px-5 py-3 text-sm font-medium shadow-[var(--shadow-lg)]"
        :class="toastClass(item.type)">

        <span>
          {{ icon(item.type) }}
        </span>

        {{ item.message }}

      </div>

    </div>
  </Teleport>
</template>


<script setup lang="ts">
type ToastType = 'success' | 'error' | 'warning' | 'info'

defineProps<{
  toastList: {
    id: number
    type: ToastType
    message: string
  }[]
}>()

const icon = (type: ToastType) => {
  const icons = {
    success: '✓',
    error: '×',
    warning: '!',
    info: 'i',
  }

  return icons[type]
}

const toastClass = (type: ToastType) => {
  return {
    success: 'bg-foreground text-background',

    error: 'bg-red-600 text-white',

    warning: 'bg-yellow-500 text-white',

    info: 'bg-blue-600 text-white',
  }[type]
}
</script>